// Live predictive search overlay (JSON API)
(function () {
  let controller;
  const debounce = (fn, w = 180) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), w); }; };
  const money = (c) => (c/100).toLocaleString(undefined,{style:'currency',currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'});
  const highlight = (text, q) => {
    if(!q) return text;
    const re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + ')', 'ig');
    return text.replace(re, '<mark>$1</mark>');
  };

  async function run(q) {
    const box = document.getElementById('psearch-results');
    if (!box) return;
    if (!q || q.length < 2) { box.innerHTML = ''; return; }
    if (controller) controller.abort();
    controller = new AbortController();
    box.setAttribute('aria-busy', 'true');
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last`;
      const res = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
      const { resources } = await res.json();
      const r = resources && resources.results || {};
      const products = r.products || [], collections = r.collections || [], articles = r.articles || [];
      if(!products.length && !collections.length && !articles.length){
        box.innerHTML = `<p class="muted" style="padding:1rem 0">No matches for "${q}". Try another word.</p>`;
        return;
      }
      box.innerHTML = `
        <div class="psearch__grid">
          <div><p class="eyebrow">Products</p>${products.map(p => `
            <a class="psearch__item" href="${p.url}">
              ${p.image ? `<img src="${p.image}" alt="${p.title}">` : ''}
              <div><div>${highlight(p.title,q)}</div><div class="muted" style="font-size:.8rem">${money(p.price)}</div></div>
            </a>`).join('') || '<p class="muted">—</p>'}
          </div>
          <div><p class="eyebrow">Collections</p>${collections.map(c => `<a class="psearch__item" href="${c.url}"><div>${highlight(c.title,q)}</div></a>`).join('') || '<p class="muted">—</p>'}
          </div>
          <div><p class="eyebrow">Journal</p>${articles.map(a => `<a class="psearch__item" href="${a.url}"><div>${highlight(a.title,q)}</div></a>`).join('') || '<p class="muted">—</p>'}
          </div>
        </div>
        <div style="margin-top:1.25rem;text-align:center"><a class="btn btn-ghost" href="/search?q=${encodeURIComponent(q)}">View all results →</a></div>`;
    } catch (e) {
      if (e.name !== 'AbortError') box.innerHTML = '<p class="muted">Search failed. Try again.</p>';
    } finally {
      box.removeAttribute('aria-busy');
    }
  }
  const debounced = debounce(run, 180);
  document.addEventListener('input', (e) => {
    const inp = e.target.closest('[data-predictive-search-input]');
    if (!inp) return;
    debounced(inp.value.trim());
  });
})();
